import React, { useEffect, useState } from "react";

const TypingAnimation = ({
  texts,
  typingInterval = 50,
  deletingInterval = 30,
  pauseDuration = 1000,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) return;

    const currentText = texts[currentTextIndex];
    const interval = isDeleting ? deletingInterval : typingInterval;

    const typingId = setInterval(() => {
      if (!isDeleting) {
        if (currentCharIndex < currentText.length) {
          setDisplayedText((prev) => prev + currentText[currentCharIndex]);
          setCurrentCharIndex((prev) => prev + 1);
        } else {
          clearInterval(typingId);
          setIsPaused(true);
          setTimeout(() => {
            setIsPaused(false);
            setIsDeleting(true);
          }, pauseDuration);
        }
      } else {
        if (currentCharIndex > 0) {
          setDisplayedText((prev) => prev.slice(0, -1));
          setCurrentCharIndex((prev) => prev - 1);
        } else {
          clearInterval(typingId);
          setIsDeleting(false);
          setCurrentTextIndex((prev) => (prev + 1) % texts.length);
        }
      }
    }, interval);

    return () => clearInterval(typingId);
  }, [
    currentCharIndex,
    currentTextIndex,
    texts,
    isDeleting,
    isPaused,
    typingInterval,
    deletingInterval,
    pauseDuration,
  ]);

  return <div className="typing-animation">{displayedText}</div>;
};

export default TypingAnimation;
